var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBEFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5F8FF",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.475 18.1679L23.6 14.4062C23.4163 14.3047 23.2099 14.2515 23 14.2515C22.7901 14.2515 22.5837 14.3047 22.4 14.4062L15.525 18.1695C15.3287 18.2769 15.1648 18.4351 15.0504 18.6275C14.9361 18.8199 14.8755 19.0394 14.875 19.2632V26.7351C14.8755 26.9589 14.9361 27.1785 15.0504 27.3709C15.1648 27.5633 15.3287 27.7214 15.525 27.8289L22.4 31.5921C22.5837 31.6936 22.7901 31.7469 23 31.7469C23.2099 31.7469 23.4163 31.6936 23.6 31.5921L30.475 27.8289C30.6713 27.7214 30.8352 27.5633 30.9496 27.3709C31.0639 27.1785 31.1245 26.9589 31.125 26.7351V19.264C31.1249 19.0398 31.0645 18.8198 30.9502 18.6269C30.8358 18.4341 30.6717 18.2755 30.475 18.1679ZM23 15.5L29.2766 18.9375L26.9508 20.2109L20.6734 16.7734L23 15.5ZM23 22.375L16.7234 18.9375L19.3719 17.4875L25.6484 20.925L23 22.375ZM16.125 20.0312L22.375 23.4515V30.1539L16.125 26.7359V20.0312ZM29.875 26.7328L23.625 30.1539V23.4546L26.125 22.0867V24.875C26.125 25.0407 26.1908 25.1997 26.3081 25.3169C26.4253 25.4341 26.5842 25.5 26.75 25.5C26.9158 25.5 27.0747 25.4341 27.1919 25.3169C27.3092 25.1997 27.375 25.0407 27.375 24.875V21.4023L29.875 20.0312V26.732V26.7328Z",
    fill: "#797F8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.1ae12e947fcc30227bf01b8f79286501.svg";
export { ForwardRef as ReactComponent };